
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 800 400"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 400V0h800z","fill":"#0051ba"}}),_c('path',{attrs:{"d":"M0 400h800V0z","fill":"#215b33"}}),_c('path',{attrs:{"d":"M0 400L800 0","stroke":"#fcd116","stroke-width":"36"}}),_c('g',{attrs:{"transform":"translate(140 120)"}},[_c('g',{attrs:{"id":"d","fill":"#fff"}},[_c('g',{attrs:{"id":"c"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M0-40V0h20z","transform":"rotate(18 0 -40)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"scale(-1 1)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(72)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(-72)"}}),_c('use',{attrs:{"xlink:href":"#c","transform":"rotate(144)"}})]),_c('g',{attrs:{"id":"f","transform":"rotate(40.6)"}},[_c('use',{attrs:{"id":"e","xlink:href":"#d","x":"-104","transform":"rotate(-40.6 -104 0)"}}),_c('use',{attrs:{"xlink:href":"#e","x":"208"}})]),_c('use',{attrs:{"xlink:href":"#f","transform":"scale(-1 1)"}})])])
          )
        }
      }
    